/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Col_ByInputs */

const vi_product_lot_history_col_by = /** @type {(inputs: Product_Lot_History_Col_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo`)
};

/**

* @param {Product_Lot_History_Col_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_col_by = /** @type {((inputs?: Product_Lot_History_Col_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Col_ByInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_col_by(inputs)
});